var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"outlined":"","type":"error"}},[_vm._v("You are not allowed to access this page.")])}
var staticRenderFns = []

export { render, staticRenderFns }